import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActionItemLibraryComponent } from './action-item-library/action-item-library.component';

const routes: Routes = [{ path: '', component: ActionItemLibraryComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActionItemRoutingModule { }
